import { useEffect, useState } from "react";
import { motion } from "motion/react";
import { Pin } from "lucide-react";
import { api } from "@/lib/api";

const CAT = { hours: "Aukiolo", info: "Tiedote", offer: "Tarjous" };

export default function Notices() {
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/notices").then((r) => setNotices(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="pt-32 pb-24 min-h-screen">
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#ff5a00] mb-3">Ajankohtaista</p>
        <h1 className="font-display text-5xl md:text-7xl tracking-tight mb-16">Tiedotteet</h1>

        {loading ? (
          <p className="font-mono text-white/40">Ladataan…</p>
        ) : notices.length === 0 ? (
          <p className="font-mono text-white/40">Ei tiedotteita juuri nyt.</p>
        ) : (
          <div className="border-t border-white/15" data-testid="notice-board">
            {notices.map((n, i) => (
              <motion.article key={n.id}
                initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.05 }}
                className="border-b border-white/15 py-10 grid grid-cols-1 md:grid-cols-4 gap-6"
                data-testid={`notice-${n.id}`}>
                <div className="font-mono text-xs uppercase tracking-widest text-white/40">
                  <p className="text-[#ff5a00]">{CAT[n.category] || "Tiedote"}</p>
                  <p className="mt-2">{new Date(n.created_at).toLocaleDateString("fi-FI")}</p>
                </div>
                <div className="md:col-span-3">
                  <h2 className="font-display text-2xl md:text-3xl tracking-tight flex items-center gap-3">
                    {n.pinned && <Pin size={18} className="text-[#ff5a00]" />}
                    {n.title}
                  </h2>
                  <p className="text-white/60 mt-3 leading-relaxed">{n.body}</p>
                </div>
              </motion.article>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
